const POLL_INTERVAL_MS = 3000;
const POLL_TIMEOUT_MS = 5 * 60 * 1000;

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const unwrapStatusPayload = (response) => response?.data?.data ?? response?.data ?? response ?? {};

/**
 * Polls GET /boq/extractData/status/:jobId until completed, failed, or timeout.
 * Returns result (same shape as legacy synchronous POST response.data).
 */
export async function pollBoqExtractJob(jobId, getStatus, { onStatus, signal } = {}) {
  if (!jobId) {
    throw new Error('Extraction job ID is missing');
  }

  const startedAt = Date.now();

  while (Date.now() - startedAt < POLL_TIMEOUT_MS) {
    if (signal?.aborted) {
      throw new Error('Drawing extraction cancelled');
    }

    const response = await getStatus(jobId);
    const statusPayload = unwrapStatusPayload(response);
    onStatus?.(statusPayload);

    if (statusPayload.status === 'completed') {
      if (!statusPayload.result) {
        throw new Error('Extraction completed but no result was returned');
      }
      return statusPayload.result;
    }

    if (statusPayload.status === 'failed') {
      throw new Error(statusPayload.error || 'Drawing extraction failed');
    }

    await sleep(POLL_INTERVAL_MS);
  }

  throw new Error('Drawing extraction timed out after 5 minutes. Please try again.');
}

export const BOQ_EXTRACT_POLL_INTERVAL_MS = POLL_INTERVAL_MS;
export const BOQ_EXTRACT_POLL_TIMEOUT_MS = POLL_TIMEOUT_MS;
